import notification from './notification';

/**
 * only use in atlas sdk
 */
export default notification;
